module.exports = __webpack_public_path__ + "img/green-level.593f3b2e.svg";